const Routes = {

    // FIELDS
    "name": "Name",
    "description": "Description",
    "status": "Status",
    "location": "Location",
    "lat": "Latitude",
    "lng": "Longitude",
    "search": "Search",

    // PAGE HEADER
    "routes": "Route",

    // ERROR
    "error_name": "Enter Name",
    "error_desc": "Enter Description",
    "error_status": "Select Status",
    "error_lat": "Enter Latitude",
    "error_lng": "Enter Longitude",
    "error_type_error": "Enter only Number",

    // TABLE HEADER
    "table_name": 'NAME',
    "table_description": "DESCRIPTION",
    "table_status": "STATUS",
    "table_locations": "LOCATIONS",
    "table_customers": "CUSTOMERS",
}

export default Routes;